import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Button,
  Checkbox,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import { Modal } from "app/components/Modal";
import { CheckboxOutlineIcon, CheckedIcon } from "app/icons";
import React from "react";

import { CHECKBOX_SIZE, useAddModelModal } from "../../hooks/useAddModelModal";
import { useStyles } from "./styles";
import AddModelField from "./AddModelField";

const AddModelModal = () => {
  const styles = useStyles();
  const {
    t,
    form,
    isLoading,
    isOpen,
    fields,
    checkboxFields,
    isValid,
    addTitle,
    onClose,
    setField,
    toggleCheckbox,
    onSubmit,
    handleMenuScroll,
    fieldLabel,
    placeholder,
    fieldValue,
  } = useAddModelModal();

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Box className={styles.modal}>
        <Box className={styles.header}>
          <Typography className={styles.title}>{addTitle}</Typography>
          <IconButton
            className={styles.closeButton}
            onClick={onClose}
            disabled={!!isLoading}
            aria-label={t("BUTTONS.CANCEL")}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        <Box className={styles.body}>
          <Box className={styles.grid}>
            {fields.map((field) => (
              <AddModelField
                key={field.key}
                field={field}
                value={fieldValue(field.key)}
                fieldLabel={fieldLabel}
                placeholder={placeholder}
                onChange={(value) => setField(field.key, value)}
                onMenuScroll={handleMenuScroll}
              />
            ))}
          </Box>

          <Box className={styles.checks}>
            {checkboxFields.map(({ key, label }) => (
              <Box
                key={key}
                className={styles.checkCard}
                onClick={() => toggleCheckbox(key)}
              >
                <Checkbox
                  checked={Boolean(form[key])}
                  disableRipple
                  onChange={(e) => setField(key, e.target.checked)}
                  onClick={(e) => e.stopPropagation()}
                  icon={
                    <CheckboxOutlineIcon
                      width={CHECKBOX_SIZE}
                      height={CHECKBOX_SIZE}
                    />
                  }
                  checkedIcon={
                    <CheckedIcon
                      width={CHECKBOX_SIZE}
                      height={CHECKBOX_SIZE}
                    />
                  }
                />
                <Typography>{fieldLabel(label)}</Typography>
              </Box>
            ))}
          </Box>

          <Box className={styles.notesField}>
            <Typography className={styles.label}>
              {fieldLabel("NOTES")}
            </Typography>
            <TextField
              className={styles.notesInput}
              fullWidth
              multiline
              variant="outlined"
              placeholder={placeholder("NOTES")}
              value={form.notes}
              InputProps={{ notched: false }}
              onChange={(e) => setField("notes", e.target.value)}
            />
          </Box>
        </Box>

        <Box className={styles.footer}>
          <Button
            className={styles.cancelButton}
            variant="outlined"
            disabled={!!isLoading}
            onClick={onClose}
          >
            {t("BUTTONS.CANCEL")}
          </Button>
          <Button
            className={styles.addButton}
            variant="contained"
            disableElevation
            disabled={!isValid || !!isLoading}
            onClick={onSubmit}
          >
            {t("BUTTONS.ADD")}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddModelModal;
